import React from 'react';
import FiverMiniViz from './viz/FiverMiniViz';
import TrafficLightMiniViz from './viz/TrafficLightMiniViz';
import NumberMiniViz from './viz/NumberMiniViz';
import BinaryMiniViz from './viz/BinaryMiniViz';

const Tracker = ({ name, tracker: { type, slug }, value, ...rest }) => (
  <div {...rest} data-testid={`tracker-${slug}`}>
    <div className="flex items-center justify-between f6">
      <span className="f7" data-testid="tracker-name">
        {name}
      </span>
      {type === 'FIVER' && <FiverMiniViz value={value} />}
      {type === 'TRAFFIC_LIGHT' && <TrafficLightMiniViz value={value} />}
      {type === 'INTEGER' && <NumberMiniViz value={value} />}
      {type === 'BINARY' && <BinaryMiniViz value={value} />}
    </div>
  </div>
);

export default Tracker;
